module.exports = __webpack_public_path__ + "static/media/huck-analysis-placeholder.5bc71b7f.png";